import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Content from 'components/Content';
// import CodeButton from 'components/CodeButton';
import BuyButton from 'components/BuyButton';
import Column from 'components/Content/Column';
import Bottle from 'components/Bottle';
import Page from 'components/Page';
import Socials from 'components/Socials';
import Pattern from 'components/Pattern';
import PureComponent from 'components/PureComponent';
import Next from 'components/Next';
import DocumentTitle from 'react-document-title';
import checkMobile from 'utils/checkMobile';
import WaveLink from 'components/WaveLink';

import warningIcon from './images/warning.svg'

class Home extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  render() {
    require('./Home.styl');

    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);
    const pageProps = {
      style: {
        backgroundImage: isMobile ? '' : `url(${this.props.backgroundImage[0]})`
      }
    };

    return (
      <Page {...pageProps}>
        <DocumentTitle title="Глубинная байкальская вода BAIKAL430" />

        {!isMobile && <Pattern left="40%" top="40%" />}

        <Content>
          <Column>
            <div className="Home__multicol">
              {/* <blockquote>
                Введя код из-под крышки BAIKAL430, вы проверяете подлинность
                воды и получаете шанс выиграть{' '}
                <WaveLink href="/puteshestviye-baikal/" target="_blank">
                  путешествие на Байкал
                </WaveLink>
              </blockquote>
              <div className={`Home-stop${isMobile ? ` Home-stop--mobile` : ``}`}>
                <img src={warningIcon} className="Home-stop__icon" />
                <span className="Home-stop__text">Временная приостановка и&nbsp;изменение программы<br />&laquo;Путешествие на&nbsp;Байкал&raquo;. <Link to="/winners">
                  Подробнее</Link></span>
              </div>
               */}
            </div>

            {/* {!isMobile && (
              <CodeButton
                style={{
                  marginTop: 40
                }}
              />
            )} */}

            {/* {!isMobile && (
              <BuyButton
                style={{
                  marginTop: 20
                }}
              />
            )} */}
          </Column>

          {isMobile && (
            <Column
              className="Content__column--bottle"
              style={{
                backgroundImage: `url(${this.props.backgroundImage[0]})`
              }}
            >
              <Bottle cover={this.props.backgroundImage[1]} />
            </Column>
          )}

          <Column>
            {/* {isMobile && (
              <CodeButton
                style={{
                  marginBottom: 20
                }}
              />
            )} */}

            {/* {isMobile && (
              <BuyButton
                style={{
                  marginBottom: 40
                }}
              />
            )} */}

            <h2>Байкал с глубины 430 метров</h2>
            <p>
              Великое озеро — национальное достояние России и всего мира. Байкал
              содержит более 20% мировых запасов чистейшей пресной воды. Являясь
              самым глубоким озером на планете, Байкал до сих пор остается
              хранителем тайн и загадок, окутанным многими легендами и
              преданиями. Местные люди издавна называют Байкал морем.
            </p>
            <p
              style={{
                marginBottom: -30
              }}
            >
              Каждый, кто хоть раз побывал на Байкале — навсегда сохраняет в
              памяти его могучую энергетику, словно останавливающую ход времени.
              Загадочный и неповторимый, великий и прекрасный. Образ Байкала,
              многоликого и непознанного — это подлинная жемчужина, достойная
              лишь высших эпитетов. Байкал уникален во всем.
            </p>
          </Column>
        </Content>

        <div className="Page__socials">
          <Socials light />
        </div>

        {isMobile && <Next to="/original" label="Уникальность" />}
      </Page>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js